export const MENU_RECOMMENDATION_SUCCESS = 'MENU_RECOMMENDATION_SUCCESS';
export const MENU_ENGINEERING_SECTION_SET_CONFIRMED = 'MENU_ENGINEERING_SECTION_SET_CONFIRMED';
export const MENU_ENGINEERING_MODIFY_SECTION = 'MENU_ENGINEERING_MODIFY_SECTION';

export const MENU_RECOMMENDATION_LIST_SUCCESS = 'MENU_RECOMMENDATION_LIST_SUCCESS';

export const PERIOD_ENGINEERING_PROFITABILITY_SUCCESS = 'PERIOD_ENGINEERING_PROFITABILITY_SUCCESS';
export const MENU_ENGINEERING_PROFITABILITY_SUCCESS = 'MENU_ENGINEERING_PROFITABILITY_SUCCESS';
export const SECTION_ENGINEERING_PROFITABILITY_SUCCESS = 'SECTION_ENGINEERING_PROFITABILITY_SUCCESS';

export const SET_ENGINEERING_PROFITABILITY_LOADING = 'SET_ENGINEERING_PROFITABILITY_LOADING';
export const VALIDATE_MENU_ENGINEERING_RECOMMENDATION = 'VALIDATE_MENU_ENGINEERING_RECOMMENDATION';
